module.exports = __webpack_public_path__ + "static/media/instluminariasmini.39078594.jpg";